import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashbaordShellComponent } from './dashbaord-shell.component';
import { RouterModule, Routes } from '@angular/router';
import { AppShellModule } from '../app-shell/app-shell.module';

@NgModule({
  declarations: [
    DashbaordShellComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AppShellModule,
  ],
  exports: [
    DashbaordShellComponent,
  ]
})
export class DashbaordShellModule { }
